/* eslint-disable react/display-name */
import type { ComponentType } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';

const draggableBackend = {
  html5: HTML5Backend,
  touch: TouchBackend,
};

type DraggableProviderType = keyof typeof draggableBackend;

export const withDraggableProvider = <ComponentProps extends object>(
  Component: ComponentType<ComponentProps>,
  type: DraggableProviderType = 'html5',
) => {
  return (props: ComponentProps) => {
    return (
      <DndProvider
        context={window}
        backend={draggableBackend[type]}
        options={{ enableMouseEvents: true }}
      >
        <Component {...props} />
      </DndProvider>
    );
  };
};
